module.exports = __webpack_public_path__ + "819fd2035adeb525d091dd9f4f2cac7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./photo.jpg
// module id = 478
// module chunks = 0